import { CommutePopupTabs, DEFAULT_COMMUTE_POPUP } from '../../interfaces/filters';
import { Action } from './actions';

export interface ICommuteSuggest {
  isActive?: boolean;
  isEnabled?: boolean;
}

export interface ICommutePopup {
  activeTab: CommutePopupTabs;
  opened: boolean;
}

export function commutePopupReducer(state: ICommutePopup, action: Action): ICommutePopup {
  switch (action.type) {
    case 'CommutePopupOpened':
      return {
        ...state,
        opened: action.opened,
      };
    case 'CommutePopupTabChanged':
      return {
        ...state,
        activeTab: action.value,
      };
    default:
      return state || DEFAULT_COMMUTE_POPUP;
  }
}

export enum CommuteButtonStatus {
  Enabled,
  Disabled,
  DisabledTooltip,
}
